"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.STYLES = exports.BLOCKS = void 0;
var react_1 = __importStar(require("react"));
var draft_js_1 = require("draft-js");
require("draft-js/dist/Draft.css");
var draftjs_to_html_1 = __importDefault(require("draftjs-to-html"));
var RichTextEditorControlButton_1 = __importDefault(require("./RichTextEditorControlButton"));
var BLOCKS;
(function (BLOCKS) {
    BLOCKS["UNSTYLED"] = "unstyled";
    BLOCKS["PARAGRAPH"] = "paragraph";
    BLOCKS["HEADER_ONE"] = "header-one";
    BLOCKS["HEADER_TWO"] = "header-two";
    BLOCKS["HEADER_THREE"] = "header-three";
    BLOCKS["HEADER_FOUR"] = "header-four";
    BLOCKS["HEADER_FIVE"] = "header-five";
    BLOCKS["HEADER_SIX"] = "header-six";
    BLOCKS["UNORDERED_LIST_ITEM"] = "unordered-list-item";
    BLOCKS["ORDERED_LIST_ITEM"] = "ordered-list-item";
    BLOCKS["BLOCKQUOTE"] = "blockquote";
    BLOCKS["CODE_BLOCK"] = "code-block";
    BLOCKS["ATOMIC"] = "atomic";
})(BLOCKS = exports.BLOCKS || (exports.BLOCKS = {}));
var STYLES;
(function (STYLES) {
    STYLES["BOLD"] = "BOLD";
    STYLES["ITALIC"] = "ITALIC";
})(STYLES = exports.STYLES || (exports.STYLES = {}));
var RichTextEditor = function (_a) {
    var placeholder = _a.placeholder, defaultValue = _a.defaultValue, onChange = _a.onChange;
    var _b = react_1.useState(function () { return draft_js_1.EditorState.createEmpty(); }), editorState = _b[0], setEditorState = _b[1];
    var _c = react_1.useState(false), blurFlag = _c[0], setBlurFlag = _c[1];
    var editorRef = react_1.useRef();
    var changeTimeout = react_1.useRef(null);
    var blurFlagTimeout = react_1.useRef(null);
    react_1.useEffect(function () {
        if (defaultValue && defaultValue.length > 0) {
            var blocksFromHTML = draft_js_1.convertFromHTML(defaultValue);
            var state = draft_js_1.ContentState.createFromBlockArray(blocksFromHTML.contentBlocks, blocksFromHTML.entityMap);
            setEditorState(draft_js_1.EditorState.createWithContent(state));
        }
        return function () {
            clearTimeout(changeTimeout.current);
        };
    }, []);
    var sendHTML = function () {
        var currentContent = editorState.getCurrentContent();
        var html = draftjs_to_html_1.default(draft_js_1.convertToRaw(currentContent));
        onChange(html);
    };
    var changeHandler = function (editorState) {
        clearTimeout(changeTimeout.current);
        setEditorState(editorState);
        changeTimeout.current = setTimeout(function () {
            sendHTML();
        }, 3000);
    };
    var blurHandler = function () {
        clearTimeout(changeTimeout.current);
        clearTimeout(blurFlagTimeout.current);
        sendHTML();
        // Stop change event firing right after blur
        blurFlagTimeout.current = setTimeout(function () {
            clearTimeout(changeTimeout.current);
        }, 1000);
    };
    var handleKeyCommand = function (command, editorState) {
        var newState = draft_js_1.RichUtils.handleKeyCommand(editorState, command);
        if (newState) {
            setEditorState(newState);
            return 'handled';
        }
        return 'not-handled';
    };
    var toggleInlineStyle = function (inlineStyle) {
        setEditorState(draft_js_1.RichUtils.toggleInlineStyle(editorState, inlineStyle));
    };
    var toggleBlockType = function (blockType) {
        setEditorState(draft_js_1.RichUtils.toggleBlockType(editorState, blockType));
    };
    var checkInlineStyle = function (targetInlineStyle) {
        var currentInlineStyles = editorState.getCurrentInlineStyle();
        var hasInlineStyle = false;
        currentInlineStyles.forEach(function (inlineStyle) {
            if (inlineStyle === targetInlineStyle) {
                hasInlineStyle = true;
            }
        });
        return hasInlineStyle;
    };
    var checkBlock = function (targetBlockType) {
        var currentSelection = editorState.getSelection();
        var currentKey = currentSelection.getStartKey();
        var currentBlockType = editorState.getCurrentContent()
            .getBlockForKey(currentKey)
            .getType();
        return currentBlockType === targetBlockType;
    };
    var focusEditor = function () {
        editorRef.current.focus();
    };
    return (react_1.default.createElement("div", { className: 'rich-text-editor', onClick: focusEditor },
        react_1.default.createElement("div", { className: 'rich-text-editor__controls flex flex-row' },
            react_1.default.createElement(RichTextEditorControlButton_1.default, { controlName: STYLES.BOLD, onMouseDown: toggleInlineStyle, selected: checkInlineStyle(STYLES.BOLD) }),
            react_1.default.createElement(RichTextEditorControlButton_1.default, { controlName: STYLES.ITALIC, onMouseDown: toggleInlineStyle, selected: checkInlineStyle(STYLES.ITALIC) }),
            react_1.default.createElement(RichTextEditorControlButton_1.default, { controlName: BLOCKS.HEADER_TWO, onMouseDown: toggleBlockType, selected: checkBlock(BLOCKS.HEADER_TWO) }),
            react_1.default.createElement(RichTextEditorControlButton_1.default, { controlName: BLOCKS.UNORDERED_LIST_ITEM, onMouseDown: toggleBlockType, selected: checkBlock(BLOCKS.UNORDERED_LIST_ITEM) }),
            react_1.default.createElement(RichTextEditorControlButton_1.default, { controlName: BLOCKS.ORDERED_LIST_ITEM, onMouseDown: toggleBlockType, selected: checkBlock(BLOCKS.ORDERED_LIST_ITEM) })),
        react_1.default.createElement("div", { className: 'rich-text-editor__editor thin-scroll' },
            react_1.default.createElement(draft_js_1.Editor, { editorState: editorState, handleKeyCommand: handleKeyCommand, onChange: changeHandler, onBlur: blurHandler, ref: editorRef, placeholder: placeholder, spellCheck: true, stripPastedStyles: true, tabIndex: 1 }))));
};
exports.default = RichTextEditor;
